import React from "react";

export const Observaciones = ({ observaciones, setObservaciones, isModoAnalisis }) => {
    return (
        <div className="mt-4">
            <h6 className="mb-2">OBSERVACIONES</h6>
            <textarea
                style={{ resize: "none" }}
                rows={3}
                className="form-control"
                value={observaciones}
                onChange={(e) => setObservaciones(e.target.value)}
                disabled={!isModoAnalisis}
            />
        </div>
    );
};
